import { render } from "./CapitalAssets.vue?vue&type=template&id=0ebe39da"
import script from "./CapitalAssets.vue?vue&type=script&lang=js"
export * from "./CapitalAssets.vue?vue&type=script&lang=js"

import "./CapitalAssets.vue?vue&type=style&index=0&id=0ebe39da&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__